export enum CommonTablePaths {
  CONTACT = 'common/contact',
  REFERENCE_CHECK = 'reference/checkCode',
  SURVEY = 'survey',
}
